export const parseDateToSpanishString = (date?: Date) => {
  if (!date) return "N/A";

  return new Date(date?.toString()).toLocaleDateString("es-MX", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};
